/**
 * Область прокрутки ленты, в которой лежит элемент.
 *
 * Ищется по разметке, а не по стилю: лента, только что показанная на своей панели, выглядит
 * прокручиваемой лишь со следующего рендера, и переход к ней сразу после показа молча пропал бы.
 */
export const getScrollAreaViewport = (element: HTMLElement | null | undefined): HTMLElement | null =>
  element?.closest<HTMLElement>('[data-radix-scroll-area-viewport]') ?? null;
